import { Input as AntdInput } from 'antd';
import styled from 'styled-components';

export const Input = styled(AntdInput)`
  padding: 8px 12px;
  border-radius: 4px;

  &.ant-input-affix-wrapper {
    border-color: #ededed;

    &.ant-input-affix-wrapper-focused {
      border-color: #00ab6b;
    }
  }

  font-size: 14px;
  line-height: 19px;

  & .ant-input-prefix {
    margin-right: 8px;
  }
`;
